module.exports = __webpack_public_path__ + "static/media/akali-icon.889b5706.png";